// external
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

// store
import {
	FetchMxrRetailerLocationsPaylod,
	FETCH_MXR_RETAILER_LOCATIONS,
	GET_CURRENT_MXR_RETAILER,
	GET_MXR_RETAILER_LOCATIONS,
	SET_MXR_RETAILER,
	GET_RETAILER_LOCATIONS_MODAL_OPEN,
	GET_SIZE,
	GET_TAKEOVER,
	TOGGLE_RETAILER_LOCATIONS_MODAL,
	GET_MXR_CONFIG,
	GET_LOCATION_CLICKED_REPORT,
	SEND_REPORT,
} from '@/store/types';

// takeover
import { Takeover } from '@/takeover';

// models
import { CardSize } from '@/interfaces/Card';
import MxrRetailer from '@/interfaces/MxrRetailer';
import { VuexAction } from '@/@types/index.d';

// components
import { IMxrConfig } from '@/interfaces/MxrConfig';
import { IReport } from '@/interfaces/IReport';
import { MxrRetailerLocation } from './components/retailer-location';

@Component({
	components: {
		MxrRetailerLocation,
	},
})
export default class RetailerLocations extends Vue {
	@Getter(GET_RETAILER_LOCATIONS_MODAL_OPEN)
	getRetailerLocationsModalOpen!: boolean;

	@Getter(GET_SIZE) getSize!: CardSize;

	@Getter(GET_MXR_RETAILER_LOCATIONS) getMxrRetailerLocations!: MxrRetailer[];

	// The currently selected walmart before the user changes the location
	@Getter(GET_CURRENT_MXR_RETAILER) getCurrentMxrRetailer!: MxrRetailer;

	@Getter(GET_TAKEOVER) getTakeover!: Takeover;

	@Getter(GET_MXR_CONFIG) mxrConfig!: IMxrConfig;

	@Getter(GET_LOCATION_CLICKED_REPORT) getLocationClickedReport!: IReport;

	@Action(SET_MXR_RETAILER) setMxrRetailer!: VuexAction<MxrRetailer>;

	@Action(FETCH_MXR_RETAILER_LOCATIONS)
	fetchMxrRetailerLocations!: VuexAction<FetchMxrRetailerLocationsPaylod>;

	@Action(TOGGLE_RETAILER_LOCATIONS_MODAL)
	toggleRetailerLocationsModal!: VuexAction<void>;

	@Action(SEND_REPORT) sendReport!: VuexAction<IReport>;

	// Holds on to the location before a zip code change happens
	private previousLocation: MxrRetailer = MxrRetailer.CreateDefault();

	// The locaiton that the user selects
	private selectedLocation: MxrRetailer = MxrRetailer.CreateDefault();

	private oldZipCode = '';

	private zipCode = '';

	private locationUpdated = false;

	get continueDisabled() {
		return (
			this.previousLocation.FulfillmentStoreId ===
			this.selectedLocation.FulfillmentStoreId
		);
	}

	get classSize(): string {
		return this.getSize;
	}

	@Watch('getRetailerLocationsModalOpen')
	onOpen() {
		if (!this.getRetailerLocationsModalOpen) {
			return;
		}
		this.locationUpdated = false;
		this.previousLocation = this.getCurrentMxrRetailer;
		this.selectedLocation = this.getCurrentMxrRetailer;
		// eslint-disable-next-line no-multi-assign
		this.oldZipCode = this.zipCode =
			this.getCurrentMxrRetailer.ZipCode.slice(0, 5);
	}

	onLocationSelected(location: MxrRetailer) {
		this.selectedLocation = location;
	}

	private setLocation(): void {
		if (
			this.selectedLocation.FulfillmentStoreId !==
			this.previousLocation.FulfillmentStoreId
		) {
			const report = this.getLocationClickedReport;
			report.mxrLocationClicked!.previousRetailer = {
				id: this.previousLocation.FulfillmentStoreId,
				location: this.previousLocation.LocationId,
				name: this.previousLocation.Chain,
			};
			this.sendReport(report);
			this.setMxrRetailer(this.selectedLocation);
			this.locationUpdated = true;
		}
		this.close();
	}

	private close(): void {
		if (!this.locationUpdated && this.oldZipCode !== this.zipCode) {
			// User changed the zip code but not the location. Return things back to how they were
			this.fetchMxrRetailerLocations({
				takeover: this.getTakeover,
				zip: this.oldZipCode,
				max: this.mxrConfig.maxStoreLocation,
				host: this.mxrConfig.host,
			} as FetchMxrRetailerLocationsPaylod);
		}
		this.toggleRetailerLocationsModal();
	}

	private setZip(): void {
		this.fetchMxrRetailerLocations({
			takeover: this.getTakeover,
			zip: this.zipCode,
			max: this.mxrConfig.maxStoreLocation,
			host: this.mxrConfig.host,
		} as FetchMxrRetailerLocationsPaylod);
	}
}
